exports.UserRole = {
    PlatAdmin: '平台管理员',
    UnitAdmin: '机构管理员',
    UnitEmp: '机构员工',
    Cta: '心理师',
    User: '普通用户'
}

exports.UserLevel = {
    Normal: '普通用户',
    Member: '认证会员',
    VIP: 'VIP会员',
    SVIP: '超级会员'
}

exports.Gender = {
    Male: '男士',
    Female: '女士',
    Secret: '保密'
}

exports.CtaLevel = {
    L01: '心理师',
    L02: '见习导师',
    L03: '助理导师',
    L04: '导师',
    L05: '资深导师',
    L06: '专家导师',
    L07: '功勋导师'
}

exports.UnitService = {
    A01: '心理测评',
    A02: '个案咨询',
    A03: '团体讲座',
    A04: '心理讲座',
    A05: '心理体验',
    A06: '公益心理活动',
    A07: '危机干预',
    A08: '心理培训',
    A09: '心理训练',
    A10: '心理矫正',
    A11: '社区矫正',
    A12: '社会心理服务'
}

exports.CertType = {
    CT01: '学历证书',
    CT02: '职业资格证书',
    CT03: '岗位证书',
    CT04: '技能证书',
    CT05: '培训证书',
    CT06: '荣誉证书',
    CT07: '聘用证书',
    CT08: '结业证书',
    CT09: '会员证',
    UT01: '登记执照',
    UT02: '办学许可证',
    UT03: '医疗许可证',
    UT04: '民非证',
    UT05: '社团证',
    UT06: '政府文件',
    UT07: '会员单位证',
    UT08: '知识产权证',
    UT09: '资格认证证书',
    UT00: '荣誉证书',
    UT11: '授权书',
    UT12: '签约证书'
}

exports.CertGrade = {
    NA: '无',
    IC: '国际证书',
    NC: '国家证书',
    PC: '省级证书',
    CC: '市级证书'
}

exports.CourseType = {
    CT01: '全日制学历',
    CT02: '在职学历',
    CT03: '继续教育',
    CT04: '连续课程',
    CT05: '长期课程',
    CT06: '短期课程',
    CT07: '微型课程'
}

exports.TeamType = {
    TM01: '委员会',
    TM02: '志愿团',
    TM03: '讲师团',
    TM04: '专家组',
    TM05: '协作组',
    TM06: '学习组'
}

exports.TeamRole = {
    TR01: '骨干',
    TR02: '咨询师',
    TR03: '讲师',
    TR04: '志愿者',
    TR05: '委员',
    TR06: '联盟'
}
